export const GET_USER_MANAGEMENT_LIST_REQUEST = 'GET_USER_MANAGEMENT_LIST_REQUEST';
export const GET_USER_MANAGEMENT_LIST_SUCCESS = 'GET_USER_MANAGEMENT_LIST_SUCCESS';
export const GET_USER_MANAGEMENT_LIST_FAILURE = 'GET_USER_MANAGEMENT_LIST_FAILURE';
